/*
 * @Description: In User Settings Edit
 * @Author: yangkq
 * @LastEditors: yangkq
 * @Date: 2019-04-27 14:11:50
 * @LastEditTime: 2019-04-27 10:05:39
 */
import request from "@/plugins/axios/request";
// 建议保存接口
export function saveAdvise(gusetbook) {
    return request({
        url: "/guestbook/saveadvise",
        method: "post",
        data: gusetbook
    });
}
// 咨询保存接口
export function saveConsultation(gusetbook) {
    return request({
        url: "/guestbook/saveconsultation",
        method: "post",
        data: gusetbook
    });
}
// 查询保存接口
export function queryPageGuestbook(gusetbook) {
    return request({
        url: "/guestbook/list",
        method: "post",
        data: gusetbook
    });
}
// 查询保存接口
export function checkcaptcha(gusetbook) {
    return request({
        url: "/nologinsystem/checkcaptcha",
        method: "post",
        data: gusetbook
    });
}
